export { NewsletterModule } from './newsletter.module';
export { NewsletterComponent } from './newsletter.component';

